import type {
  Nullable,
  TaskGoods,
  TaskGoodsRule,
  TaskLimitTime,
  TaskLimitClaim,
  TaskStepCard,
  TaskForm,
  TaskPurchaseItem,
  TaskReviewItem,
  TaskReviewData,
  TaskAfterSalesForm,
  TaskAfterSalesParams,
  TaskAfterSalesRecord
} from '@xianlaibang/shared/types'

/** 首页合作伙伴应用记录（兼容接口不同版本的字段命名） */
export interface TaskAppRecordItem {
  taskAppRecordId?: number | string
  appRecordId?: number | string
  id?: number | string
  appName?: string
  taskAppName?: string
  name?: string
  title?: string
  appIcon?: string
  taskAppIcon?: string
  icon?: string
  appLogo?: string
  logo?: string
  image?: string
  [key: string]: unknown
}

// 任务相关productTagId固定为2
const productTagId = 6

export const taskApi = {
  /** 首页合作伙伴列表 */
  getTaskAppRecordPage: (params: { pageNum: number; pageSize: number }) => {
    const { get } = useHttp()
    return get<null, TaskAppRecordItem>('/task/taskAppRecord/page', params)
  },
  // 查询任务产品列表
  getTaskGoodsList: () => {
    const { get } = useHttp();
    return get<TaskGoods[]>('/task/taskGoods/list/user', { productTagId });
  },
  // 查询任务产品规则
  getTaskGoodsRule: (taskGoodsId: number) => {
    const { get } = useHttp();
    return get<Nullable<TaskGoodsRule>>(`/task/taskRule/${taskGoodsId}`);
  },
  // 获取任务限制时间
  getTaskLimitTime: (limitType: number) => {
    const { get } = useHttp();
    return get<TaskLimitTime[]>('/task/taskLimitTime', { limitType });
  },
  // 获取任务领取限制
  getTaskLimitClaim: () => {
    const { get } = useHttp();
    return get<TaskLimitClaim[]>('/task/taskLimitClaim');
  },
  // 获取产品任务步骤卡
  getTaskStepCard: () => {
    const { get } = useHttp();
    return get<TaskStepCard[]>(`/task/taskStep`);
  },
  // 用户发布任务
  publishTask: (data: TaskForm) => {
    const { post } = useHttp();
    return post<null>('/task/taskPurchase', data);
  },
  // 获取发布任务列表(包含草稿箱)
  getTaskPurchase: (data: { page: number, size: number }) => {
    const { get } = useHttp();
    return get<null, TaskPurchaseItem>('/task/taskPurchase/publish', data);
  },
  // 获取任务中心列表(不包含草稿箱)
  getTaskList: (data: { page: number, size: number }) => {
    const { get } = useHttp();
    return get<null, TaskPurchaseItem>('/task/taskPurchase/taskList', data);
  },
  // 获取任务详情
  getTaskDetail: (taskOrderPurchaseId: number) => {
    const { get } = useHttp();
    return get<TaskForm>(`/task/taskPurchase/${taskOrderPurchaseId}`);
  },
  // 更新任务状态(取消或删除任务)
  updateTaskStatus: (data: { taskOrderPurchaseId: number, reviewStatus: string }) => {
    const { put } = useHttp();
    return put<null>('/task/taskPurchase', data );
  },
  // 任务加量
  addTaskQuantity: (data: {taskOrderPurchaseId: number, taskCount: string, transactionPassword: string } ) => {
    const { post } = useHttp();
    return post<null>('/task/taskPurchaseDetails', data);
  },
  // 获取任务接单列表
  getTaskOrderList: (data: { taskOrderPurchaseId: number | undefined, status: string, pageNum: number, pageSize: number }) => {
    const { get } = useHttp();
    return get<null, TaskReviewItem>('/task/taskOrderSupply/list/merchant', data);
  },
  // 获取任务待审核列表
  getTaskAuditList: (taskOrderPurchaseId: number) => {
    const { get } = useHttp();
    return get<TaskReviewData>('/task/taskOrderSupply/list/review', { taskOrderPurchaseId });
  },
  // 审核任务订单
  auditTaskOrder: (data: { taskOrderSupplyId: number, status: string, reason?: string }) => {
    const { put } = useHttp();
    return put<null>('/task/taskOrderSupply/review', data);
  },
  // 任务上下架
  updateTaskShelf: (data: {taskOrderPurchaseId: number, status: string}) => {
    const { put } = useHttp();
    return put<null>(`/task/taskPurchase/taskStatus`, data);
  },
  // 任务用户发起售后
  addAfterSales: (data: TaskAfterSalesForm) => {
    const { post } = useHttp()
    return post<null | string>(`/task/taskPurchase/afterSales`, data)
  },
  // 任务用户获取售后记录
  getAfterSalesList: (query: TaskAfterSalesParams) => {
    const { get } = useHttp()
    return get<null, TaskAfterSalesRecord>(`/task/taskAfterSales`, query)
  },
  // 任务用户获取售后详情
  getAfterSales: (taskOrderPurchaseId: string) => {
    const { get } = useHttp()
    return get<null, TaskAfterSalesRecord>(`/task/taskAfterSales`, { taskOrderPurchaseId })
  },
  // 模糊查询任务列表
  getTaskNameList: (query: { taskName: string }) => {
    const { get } = useHttp()
    return get<string[]>('/task/taskPurchase/getTaskNamesByName', query)
  }
}
